/*
  LGB GA4 click events (31 Oct 2026). Loaded with "defer" from layout/theme.liquid.

  Sends whatsapp_click, phone_click, directions_click and visit_booking_click.

  HOW GOOGLE ANALYTICS IS LOADED ON THIS STORE (checked 31 Oct 2026):
  GA4 (G-W8LCHBN1YK) comes from Shopify's Google & YouTube app, which runs as a sandboxed
  "web pixel". That means there is NO window.gtag on the page, so step 1 below does nothing
  today. Step 2 publishes the same events on Shopify's own customer-events bus; the custom
  pixel in theme-changes/MANIFEST-home.md picks them up and forwards them to GA4, and Shopify
  only runs it when the visitor's cookie choice allows analytics.
  If gtag is ever added to the page directly, step 1 starts working with no change here.

  No personal data is sent: just the event name, the link (without its ?query) , the link text
  and the page path.
*/
(function () {
  if (window.__lgbGa4Clicks) return;
  window.__lgbGa4Clicks = true;

  function eventFor(href) {
    var h = (href || '').toLowerCase();
    if (!h) return null;
    if (h.indexOf('wa.me/') > -1 || h.indexOf('api.whatsapp.com') > -1 || h.indexOf('whatsapp://') === 0) return 'whatsapp_click';
    if (h.indexOf('tel:') === 0) return 'phone_click';
    if (h.indexOf('google.com/maps') > -1 || h.indexOf('maps.google.') > -1 || h.indexOf('goo.gl/maps') > -1 ||
        h.indexOf('maps.app.goo.gl') > -1 || h.indexOf('maps.apple.com') > -1) return 'directions_click';
    if (h.indexOf('calendly.com') > -1 || h.indexOf('#book-a-visit') > -1 ||
        (h.indexOf('hubspot') > -1 && h.indexOf('meetings') > -1)) return 'visit_booking_click';
    return null;
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var name = eventFor(a.getAttribute('href'));
    if (!name) return;
    var params = {
      link_url: String(a.href || '').split('?')[0],
      link_text: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
      page_path: location.pathname
    };
    /* 1. Direct to GA4 when gtag is on the page */
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', name, params); } catch (err) {}
    }
    /* 2. Shopify customer-events bus (for the custom pixel) */
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, params);
      }
    } catch (err) {}
  }, true);
})();
